import { render, staticRenderFns } from "./NewSubmissionForm.vue?vue&type=template&id=24d6c432&scoped=true"
import script from "./NewSubmissionForm.vue?vue&type=script&lang=js"
export * from "./NewSubmissionForm.vue?vue&type=script&lang=js"
import style0 from "./NewSubmissionForm.vue?vue&type=style&index=0&id=24d6c432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d6c432",
  null
  
)

export default component.exports